import React, { Component } from "react";
import { Router, Switch, Route } from "react-router-dom";
import {
  ProtectedRoute,
  AdminRoute,
} from "./utils/ProtectedRoute/ProtectedRoute.jsx";
import Header from "./components/Header/Header.jsx";
/* import LanguageSelector from "./utils/LanguageSelector/LanguageSelector.js"; */
import {
  StartScreen,
  RequestForm,
  UserDashboard,
  UserSignIn,
  UserRegister,
  ForgotPassword,
  ResetPassword,
  TrackOrder,
  ConfirmAccount,
  AdminDashboard,
  ProposalStatusChange,
  DocumentsDashboard,
} from "./pages/index.ts";
import history from "./history";
import ScrollToTop from "react-router-scroll-top";

export default class Routes extends Component {
  render() {
    return (
      <Router history={history}>
        <ScrollToTop />
        {/*       <LanguageSelector /> */}
        <Header />
        <Switch>
          <Route
            path="/proposal/:id/:response"
            component={ProposalStatusChange}
          />
          <Route path="/documents" component={DocumentsDashboard} />
          <Route path="/track/:id" component={TrackOrder} />
          <Route path="/track" component={TrackOrder} />
          <Route path="/confirmation/:JWT" component={ConfirmAccount} />
          <Route path="/signin" component={UserSignIn} />
          <Route path="/forgotpassword" component={ForgotPassword} />
          <Route path="/resetpassword/:JWT" component={ResetPassword} />
          <Route path="/register" component={UserRegister} />
          <Route path="/" exact component={StartScreen} />
          <Route path="/form" component={RequestForm} />
          <ProtectedRoute path="/dashboard" component={UserDashboard} />
          <AdminRoute path="/admin" component={AdminDashboard} />
          <Route
            path="*"
            component={() => {
              return <div className="flex-center">404 NOT FOUND</div>;
            }}
          />
        </Switch>
      </Router>
    );
  }
}
